export default {
    name: 'SkipLeft',
    dimensions: { width: 10, height: 10 },
    content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C-4.82823e-08 9.55228 0.447715 10 1 10C1.55229 10 2 9.55228 2 9L2 1C2 0.447715 1.55229 5.41014e-07 1 4.92732e-07C0.447716 4.4445e-07 -2.06009e-07 0.447715 6.99383e-07 1L0 9Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.70686 1.70711C10.0974 1.31658 10.0974 0.683418 9.70686 0.292894C9.31634 -0.0976312 8.68317 -0.0976312 8.29265 0.292894L4.29265 4.29289C3.90212 4.68342 3.90212 5.31658 4.29265 5.70711L8.29265 9.70711C8.68317 10.0976 9.31634 10.0976 9.70686 9.70711C10.0974 9.31658 10.0974 8.68342 9.70686 8.29289L6.41397 5L9.70686 1.70711Z" fill="currentColor"/>
    `
};
